import React from 'react';
import PropTypes from 'prop-types';

import NavLink from 'src/components/NavLink/NavLink';

export default function HeaderFooterLink({
  'data-analytics': analytics,
  href,
  children,
  ...restProps
}) {
  return (
    <NavLink
      allowPropagation
      analytics={analytics}
      children={children}
      location={href}
      {...restProps}
    />
  );
}

HeaderFooterLink.propTypes = {
  'data-analytics': PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node
};

HeaderFooterLink.defaultProps = {
  'data-analytics': '',
  href: '',
  children: null
};
